import React, {Component} from 'react';
import { DOWNLOAD_SVG_URL } from '../utils/urls.js'

class Sidebar extends Component {
    render() {
        const {appState, updateAppState, sidebarOpen} = this.props

        return (<aside className={`sidebar ${sidebarOpen && "sidebar--open"}`}>
            <div className="sidebar__overlay" onClick={e => {
                updateAppState({
                    sidebarOpen: false
                });
            }}>
                <div className="sidebar__close-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M6.34314575 6.34314575L17.6568542 17.6568542M6.34314575 17.6568542L17.6568542 6.34314575"/>
                    </svg>
                </div>
            </div>
            <div className="sidebar__inner">
                <div className="control-section">
                    <h2 className="heading heading--small">border</h2>
                    <div className="control">
                        <button
                            type="button"
                            name="button"
                            className="control__item control__item--button"
                            aria-label="Increase icons' border by 1px"
                            disabled={ appState.iconsBorder <= 0 }
                            onClick={e => {
                                const number = --appState.iconsBorder;

                                updateAppState({
                                    iconsBorder: number < 0 ? 0 : number,
                                });
                            }}>-
                        </button>
                        <input type="text" name="iconsBorder" value={appState.iconsBorder} onChange={e => this.changeValue(e)} className="control__item control__item--input" aria-label="Icons' border width (in pixels)"/>
                        <button
                            type="button"
                            name="button"
                            aria-label="Decrease icons' border by 1px"
                            className="control__item control__item--button"
                            onClick={e => {
                                updateAppState({
                                    iconsBorder: ++appState.iconsBorder
                                });
                            }}>+</button>
                    </div>
                </div>
                <div className="control-section">
                    <h2 className="heading heading--small">size</h2>
                    <div className="control">
                        <button
                            type="button"
                            name="button"
                            className="control__item control__item--button"
                            aria-label="Increase icons' size by 8px"
                            disabled={ appState.iconsWidth <= 0 }
                            onClick={e => {
                                const number = parseInt(appState.iconsWidth, 10) - 8;

                                updateAppState({
                                    iconsWidth: number < 0 ? 0 : number,
                                });
                            }}>
                            -
                        </button>
                        <input type="text" name="iconsWidth" value={appState.iconsWidth} onChange={e => this.changeValue(e)} className="control__item control__item--input" aria-label="Icons' size (in pixels)"/>
                        <button
                            type="button"
                            name="button"
                            className="control__item control__item--button"
                            aria-label="Decrease icons' size by 8px"
                            onClick={e => {
                                updateAppState({
                                    iconsWidth: parseInt(appState.iconsWidth, 10) + 8
                                });
                        }}>
                            +
                        </button>
                    </div>
                </div>
                <div className="control-section">
                    <h2 className="heading heading--small">cap &amp; corner</h2>
                    <div className="control">
                        <div className="control__item control__item--radio">
                            <input
                                type="radio"
                                name="styleRadio"
                                id="styleSquare"
                                checked={appState.iconsJoin === 'miter' && appState.iconsLinecap === 'square' }
                                onChange={e => {
                                    updateAppState({
                                        iconsJoin: 'miter',
                                        iconsLinecap: 'square'
                                    });
                                }}
                            />
                            <label htmlFor="styleSquare">
                                <span className="sr-only">Set linecaps to square and linejoins to miter</span>
                                <svg width="60" height="60">
                                    <g fill="none" fillRule="evenodd" transform="translate(6 12)">
                                        <path stroke="#0E3FF2" d="M6 12l12 12 12-12 12 12"/>
                                        <rect width="4" height="4" x="4" y="10" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="16" y="21" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="28" y="11" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="40" y="22" fill="#0E3FF2" rx="2"/>
                                        <path stroke="#0E3FF2" strokeWidth="2" d="M18 35.314L.343 17.657 11.657 6.343 18 12.686l12-12 17.657 17.657-11.314 11.314L30 23.314z"/>
                                    </g>
                                </svg>
                            </label>
                        </div>
                        <div className="control__item control__item--radio">
                            <input
                                type="radio"
                                name="styleRadio"
                                id="styleRoundSquare"
                                checked={appState.iconsJoin === 'miter' && appState.iconsLinecap === 'round' }
                                onChange={e => {
                                    updateAppState({
                                        iconsJoin: 'miter',
                                        iconsLinecap: 'round'
                                    });
                                }}
                            />
                            <label htmlFor="styleRoundSquare">
                                <span className="sr-only">Set linecaps to square and linejoins to round</span>
                                <svg width="60" height="60">
                                    <g fill="none" fillRule="evenodd" transform="translate(4 12)">
                                        <path stroke="#0E3FF2" strokeLinecap="round" d="M8 12l12 12 12-12 12 12"/>
                                        <rect width="4" height="4" x="6" y="10" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="18" y="21" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="30" y="11" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="42" y="22" fill="#0E3FF2" rx="2"/>
                                        <path stroke="#0E3FF2" strokeWidth="2" d="M32 23.314l-12 12L2.343 17.657A8 8 0 1 1 13.657 6.343L20 12.686l12-12 17.657 17.657a8 8 0 1 1-11.314 11.314L32 23.314z"/>
                                    </g>
                                </svg>
                            </label>
                        </div>
                        <div className="control__item control__item--radio">
                            <input
                                type="radio"
                                name="styleRadio"
                                id="styleRound"
                                checked={appState.iconsJoin === 'round' && appState.iconsLinecap === 'round' }
                                onChange={e => {
                                    updateAppState({
                                        iconsJoin: 'round',
                                        iconsLinecap: 'round'
                                    });
                                }}
                            />
                            <label htmlFor="styleRound">
                                <span className="sr-only">Set linecaps and linejoins to round</span>
                                <svg width="60" height="60">
                                    <g fill="none" fillRule="evenodd" transform="translate(4 16)">
                                        <path stroke="#0E3FF2" strokeLinecap="round" strokeLinejoin="round" d="M8 8l12 12L32 8l12 12"/>
                                        <rect width="4" height="4" x="6" y="6" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="18" y="17" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="30" y="7" fill="#0E3FF2" rx="2"/>
                                        <rect width="4" height="4" x="42" y="18" fill="#0E3FF2" rx="2"/>
                                        <path stroke="#0E3FF2" strokeWidth="2" d="M32 19.314l-6.343 6.343a8 8 0 0 1-11.314 0l-12-12A8 8 0 1 1 13.657 2.343L20 8.686l6.343-6.343a8 8 0 0 1 11.314 0l12 12a8 8 0 1 1-11.314 11.314L32 19.314z"/>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="control-section">
                    <h2 className="heading heading--small">colour</h2>
                    <div className="control">
                        <div className="control__item control__item--swatch">
                            <div className="control__item__swatch" style={{
                                    background: `${appState.iconsColor}`
                                }}></div>
                        </div>
                        <input type="text" name="iconsColor" onChange={e => this.changeValue(e) } value={appState.iconsColor} className="control__item control__item--input control__item--3 control__item--left" aria-label="Icons' color given in any valid format"/>
                    </div>

                </div>
                <div className="control-section control-section--switch">
                    <span className="heading heading--small">dark mode</span>
                    <div className="switch">
                        <input
                            className="switch__input"
                            id="darkmodeSwitch"
                            type="checkbox"
                            name="darkmodeSwitch"
                            onChange={e => {
                                updateAppState({
                                    darkMode: appState.darkMode ? false : true
                                });
                            }}
                            checked={appState.darkMode}
                        />
                        <label className="switch__paddle" htmlFor="darkmodeSwitch">
                            <span className="sr-only">Switch on dark mode</span>
                        </label>
                    </div>
                </div>
                <div className="sidebar__export">
                    <button
                        type="button"
                        target='_blank'
                        name="button"
                        className="button button--primary button--full"
                        id="downloadButton"
                        download
                        onClick={ ()=>{ this.downloadSvgs() } }
                    >
                        { appState.selectedSvgs.length === 0 ? `Export all icons` : appState.selectedSvgs.length === 1 ? `Export 1 icon` : `Export ${appState.selectedSvgs.length} icons`  }
                    </button>

                    <p className="sidebar__note">choose some icons on right to narrow your selection</p>
                </div>
            </div>
        </aside>);
    }

    changeValue(e, dropdown) {
        this.props.updateAppState({
            [e.target.name]: e.target.value
        }, () => console.log(this.props.appState))
    }

    downloadSvgs(){
      fetch(DOWNLOAD_SVG_URL, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(this.props.appState),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status} - ${response.statusText}`);
          }
          return response.arrayBuffer()
        })
        .then(buffer => {
          const blob = new Blob([ buffer ]);

          this.props.showModal()

          const a = document.createElement('a');
          a.href = URL.createObjectURL( blob );
          a.download = 'ikonate.zip';

          document.body.appendChild(a); // Must appendChild in firefox
          a.click();
        })
        .catch(e => console.error(e));
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js